<template>
    <aboutProgram v-if="openModal" @closeModal="openModal = false" :is-premium="true" :item="selectedItem"
        @buyNewItem="openExtend = true" />
    <extend v-if="openExtend" @closeModal="openExtend = false" :props-item="selectedItem" :is-premium="true" />
    <PlatformLayout title="Премиум опции">
            <div class="block">
                <div class="block__in" v-if="newOptions.length > 0">
                    <p class="block__in__title">Услуги наставничества</p>
                    <div class="block__in__bot">
                        <div class="block__in__bot__in" v-for="item in visibleOptions" :key="item.id">
                            <grantCard :item="item" :is-to-buy="true" @openExtend="newItem" />
                        </div>
                    </div>
                </div>
                <button class="more" v-if="newOptions.length > 10" @click="toggleShowMore('newOptions')">
                    {{ showMoreGuides ? 'Скрыть' : 'Показать больше' }}
                </button>
                <div class="block__in" v-if="onlineCources.length > 0">
                    <p class="block__in__title">Авторские онлайн курсы</p>
                    <div class="block__in__bot">
                        <div class="block__in__bot__in" v-for="item in visibleOnline" :key="item.id">
                            <grantCard :item="item" :is-to-buy="true" @openExtend="newItem" />
                        </div>
                    </div>
                </div>
                <button class="more" v-if="onlineCources.length > 10" @click="toggleShowMore('online')">
                    {{ showMoreGuides ? 'Скрыть' : 'Показать больше' }}
                </button>
                <div class="block__in" v-if="restock.length > 0">
                    <p class="block__in__title">Дополнительные услуги</p>
                    <div class="block__in__bot">
                        <div class="block__in__bot__in" v-for="item in visibleRestock" :key="item.id">
                            <grantCard :item="item" :is-to-buy="true" @openExtend="newItem" />
                            <div 
                                class="block__in__bot__in__backdrop" 
                                v-if="$store.state.role == 'guest'"
                                @click="toggleBlock(true)"
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" height="48px" viewBox="0 -960 960 960" width="48px" fill="#fff"><path d="M753-249q27.92 0 47.46-19.56t19.54-47.5Q820-344 800.46-363q-19.54-19-47.46-19-27.5 0-46.75 19.35-19.25 19.36-19.25 47 0 27.65 19.25 47.15T753-249Zm-.21 133Q786-116 815-131.5t47-42.5q-26-14-53-22.5t-56-8.5q-29 0-56 8.5T644-174q18 27 46.79 42.5 28.78 15.5 62 15.5ZM350-634h260v-93q0-57-37.5-95T480-860q-55 0-92.5 38T350-727v93ZM557-80H220q-23 0-41.5-18.5T160-140v-434q0-23 18.5-41.5T220-634h70v-93q0-81 55-137t135-56q80 0 135 56t55 137v93h70q23 0 41.5 18.5T800-574v87q-13-3-27-4t-33-1v-82H220v434h301q7 17 15 30.5T557-80Zm196 34q-79 0-136-57t-57-136q0-79 57-136t136-57q79 0 136 57t57 136q0 79-57 136T753-46ZM220-574v434-434Z"/></svg>
                            </div>
                        </div>
                    </div>
                </div>
                <button class="more" v-if="newOptions.length > 10" @click="toggleShowMore('restock')">
                    {{ showMoreGuides ? 'Скрыть' : 'Показать больше' }}
                </button>
            </div>
    </PlatformLayout>
</template>
<script>
import PlatformLayout from '@/components/platform/PlatformLayout.vue';
import newCardComponent from '@/components/newCardComponent.vue';
import grantCard from '@/components/grantCard.vue';
import aboutProgram from '@/components/newPlatform/aboutProgram.vue';
import extend from '@/components/newPlatform/extend.vue';
import { Swiper, SwiperSlide, } from "swiper/vue";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import SwiperCore, { A11y, Autoplay } from "swiper";
import { Navigation, Pagination } from 'swiper';
import "swiper/swiper.min.css";
SwiperCore.use([Navigation, Pagination, A11y, Autoplay])
import {mapActions} from 'vuex'
import 'vue3-toastify/dist/index.css';
import axios from "axios";
export default {
    components: {
        PlatformLayout, Swiper, SwiperSlide, newCardComponent, grantCard, aboutProgram, extend
    },
    data() {
        return {
            activeTab: 'list',
            selectedStip: -1,
            selectedStep: -1,
            data: false,
            newOptions: false,
            selectedItem: false,
            restock: false,
            onlineCources: false,
            visibleOptions: [],
            visibleRestock: [],
            visibleOnline: [],
            openModal: false,
            openExtend: false,
            showMoreOptions: false,
            showMoreRestock: false,
            showMoreOnline: false,
        }
    },
    methods: {
        ...mapActions(["toggleBlock"]),
        toggleShowMore(type) {
            if (type === 'newOptions') {
                if (this.showMoreOptions) {
                    // Collapse to show 5 items
                    this.visibleOptions = this.newOptions.slice(0, 10);
                } else {
                    // Show all items
                    this.visibleOptions = this.newOptions;
                }
                this.showMoreOptions = !this.showMoreOptions;
            } else if (type === 'restock') {
                if (this.showMoreRestock) {
                    // Collapse to show 5 items
                    this.visibleRestock = this.restock.slice(0, 10);
                } else {
                    // Show all items
                    this.visibleRestock = this.restock;
                }
                this.showMoreRestock = !this.showMoreRestock;
            }
            else if (type === 'online') {
                if (this.showMoreOnline) {
                    // Collapse to show 5 items
                    this.visibleOnline = this.onlineCources.slice(0, 10);
                } else {
                    // Show all items
                    this.visibleOnline = this.onlineCources;
                }
                this.showMoreOnline = !this.showMoreOnline;
            }
        },
        newItem(item) {
            this.selectedItem = item;
            this.openModal = true
        },
        async getPage() {
            await axios.get(`/platform/premium-options-2`)
                .then(res => {
                    this.data = res.data.data
                    this.newOptions = this.data.filter(item => item.type === 6);
                    this.visibleOptions = this.newOptions.slice(0, 10); 
                    this.restock = this.data.filter(item => item.type === 7);
                    this.visibleRestock = this.restock.slice(0, 10); 
                    this.onlineCources = this.data.filter(item => item.type === 8);
                    this.visibleOnline = this.onlineCources.slice(0, 10);
                })
                .catch(err => {
                })

        },
    },

    async created() {
        this.getPage();
    },
}
</script>
<style lang="scss" scoped>
.line {
    border-top: 1px solid #0000001A;
    width: 100%;
}

.block {
    display: flex;
    flex-direction: column;
    gap: min(max(18px, calc(1.125rem + ((1vw - 7.68px) * 1.0417))), 30px);

    &__in {
        display: flex;
        flex-direction: column;
        gap: min(max(14px, calc(0.875rem + ((1vw - 7.68px) * 0.5208))), 20px);

        &__title {
            color: #0000008A;
            font-size: min(max(16px, calc(1rem + ((1vw - 7.68px) * 0.6944))), 24px);
        }

        &__bot {
            display: flex;
            flex-wrap: wrap;
            gap: 2.5%;
            row-gap: min(max(14px, calc(0.875rem + ((1vw - 7.68px) * 0.5208))), 20px);

            &__in {
                width: 18%;
                position: relative;
                &__backdrop {
                    position: absolute;
                    z-index: 1000;
                    inset: 0;
                    background-color: rgba(0,0,0, 0.5);
                    border-radius: 10px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
            }
        }
    }

    @media(max-width:768px) {
        gap: min(max(10px, calc(0.625rem + ((1vw - 7.68px) * 0.434))), 15px);

        &__in {
            gap: min(max(10px, calc(0.625rem + ((1vw - 7.68px) * 0.434))), 15px);

            &__title {
                font-size: min(max(13px, calc(0.8125rem + ((1vw - 7.68px) * 0.434))), 18px);
            }

            &__bot {
                gap: 2%;
                row-gap: min(max(10px, calc(0.625rem + ((1vw - 7.68px) * 0.434))), 15px);

                &__in {
                    width: 49%;
                }
            }
        }
    }
}
</style>